"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
function default_1() {
    const useMatchMedia = (mediaQuery) => {
        const match = window.matchMedia(mediaQuery);
        const ref = (0, vue_1.reactive)({ value: match.matches });
        if ("addEventListener" in match)
            match.addEventListener("change", () => (ref.value = match.matches));
        else if ("addListener" in match)
            match.addListener(() => (ref.value = match.matches));
        return ref;
    };
    const isLt1024 = useMatchMedia("not all and (min-width: 1024px)");
    const isMobile = (0, vue_1.computed)(() => isLt1024.value);
    return {
        isMobile,
    };
}
exports.default = default_1;
